export default (auth) => {
    return auth.split('JWT ')[1];
}
